import axios from "axios";
import { useEffect, useRef, useState } from "react";

import { CountryPhoneCodeSelect } from 'base/ui/misc';
import { useRerender } from "base/utils/common";


const NeedPhonePopup = ({default_values, invalid_phone_number, submit_btn_text, onSubmit, description}) => {
    const { country_phone_code, phone_number } = default_values || {};
    const ctx = useRef({ country_phone_code }).current;
    const [error, setError] = useState(invalid_phone_number);
    const rerender = useRerender()

    useEffect(() => {
        if (default_values) {
            Object.assign(ctx, default_values);
        }
    }, [default_values])

    useEffect(() => {
        if (!country_phone_code) {
            axios.get("/user/location").then(
                (resp) => {
                    if (resp.data) {
                        ctx.country_phone_code = resp.data.phone_code
                        rerender()
                    }
                }
            )
        }
    }, [])

    const submit = () => {
        const phone_number = ctx.phone_number?.trim();
        const country_phone_code = ctx.country_phone_code
        if (!country_phone_code || !phone_number) {
            setError(true)
        } else {
            onSubmit({ country_phone_code, phone_number })
        }
    }

    return (
        <div className='tw-p-4'>
            <div className='tw-text-sm tw-text-gray-600 tw-mb-6'>
                {description || 'Please provide your Whatsapp Phone Number to continue.'}
            </div>
            <div className='tw-rounded tw-border tw-flex tw-p-1 tw-w-full tw-mt-6'>
                <CountryPhoneCodeSelect
                    onChange={(country_phone_code) => {ctx.country_phone_code = country_phone_code}}
                    default_phone_code={`+${ctx?.country_phone_code}`}
                />
                <input type='number' className='tw-flex-1 tw-outline-0 tw-text-md tw-border-l tw-pl-4 tw-appearance-none focus:tw-outline-none focus:tw-ring-0 focus-visible:tw-outline-none focus-visible:tw-ring-0' 
                    placeholder='Phone Number' 
                    defaultValue={phone_number}
                    onChange={(e) => {ctx.phone_number = e.target.value}}
                />
            </div>
            {error ? <div className='tw-text-red-600 tw-text-xs tw-mt-1'>Please enter a valid Phone Number</div> : null}
            <button
                type="button"
                className="tw-bg-secondary-lighter tw-w-full tw-py-2 tw-rounded tw-text-sm tw-mt-8 tw-text-white"
                onClick={submit}
            >{submit_btn_text || 'Submit'}</button>
        </div>
    )
}

export default NeedPhonePopup;
